import { render, staticRenderFns } from "./balances-link.vue?vue&type=template&id=af1905dc&"
import script from "./balances-link.vue?vue&type=script&lang=js&"
export * from "./balances-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports